

































































































































import { defineComponent, reactive } from '@vue/composition-api';
import { SelectOption } from '../types';
import OlbButton from '../../button';
import OlbIcon from '../../icon';
import { OlbInput, OlbFlyoutSelect } from '../../form';

export default defineComponent({
	components: {
		OlbButton,
		OlbIcon,
		OlbInput,
		OlbFlyoutSelect,
	},
	props: {
		actionurl: {
			type: String,
		},
		hide: {
			type: String,
		},
		searchbutton: {
			type: String,
		},
		headline: {
			type: String,
		},
		roomsfrom: {
			type: String,
		},
		roomsfromvalue: {
			type: String,
		},
		roomsto: {
			type: String,
		},
		roomstovalue: {
			type: String,
		},
		livingspacefrom: {
			type: String,
		},
		livingspacefromvalue: {
			type: String,
		},
		livingspaceto: {
			type: String,
		},
		livingspacetovalue: {
			type: String,
		},
		landareafrom: {
			type: String,
		},
		landareafromvalue: {
			type: String,
		},
		landareato: {
			type: String,
		},
		landareatovalue: {
			type: String,
		},
		pricefrom: {
			type: String,
		},
		pricefromvalue: {
			type: String,
		},
		priceto: {
			type: String,
		},
		pricetovalue: {
			type: String,
		},
		category: {
			type: String,
		},
		categoryoptions: {
			type: Array as () => SelectOption[],
		},
	},
	setup(props) {
		const formData = reactive({
			roomsfrom: props.roomsfromvalue || '',
			roomsto: props.roomstovalue || '',
			livingspacefrom: props.livingspacefromvalue || '',
			livingspaceto: props.livingspacetovalue || '',
			landareafrom: props.landareafromvalue || '',
			landareato: props.landareatovalue || '',
			pricefrom: props.pricefromvalue || '',
			priceto: props.pricetovalue || '',
			category: '',
		});
		return { formData };
	},
});
